<div
  class="w-full p-8 bg-zinc-100 outline-none focus:outline-none flex-col justify-start items-start h-[calc(100%-1rem)] max-h-full"
>
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div
    class="self-stretch h-full flex-col justify-start items-start gap-6 flex"
  >
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <div
          class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600"
        >
          <h2
            class="text-lg text-center font-semibold text-gray-900 dark:text-white"
          >
            Notifier les invités par email
          </h2>
        </div>
        <div class="p-4 md:p-5" *ngIf="!loading">
          <!-- Messages d'erreur -->
          <div
            class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="formValidity"
          >
            <strong class="font-bold">Erreur ! </strong>
            <span class="block sm:inline"
              >Merci de remplir tous les champs</span
            >
          </div>

          <div
            class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="error"
          >
            <strong class="font-bold">Erreur!</strong>
            <span class="block sm:inline"
              >Erreur rencontrée avec le fichier. Veuillez corriger et réessayer
              !</span
            >
          </div>

          <!-- Message de succès -->
          <div
            class="bg-green-500 border border-400 text-white px-4 py-3 rounded relative"
            role="alert"
            *ngIf="succes"
          >
            <strong class="font-bold">Réussite!</strong>
            <span class="block sm:inline"
              >Ajout effectué, un email a été envoyé à tous ces invité pour leur
              confirmation à l’actvité
            </span>
          </div>

          <form class="w-full" [formGroup]="sendMessageForm">
            <div class="mb-6">
              <!-- Sélection de l'activité -->
              <label
                class="block text-lg font-semibold text-gray-700"
                for="activity"
                >Activité</label
              >
              <!------------------------------------------------->
              <select
                formControlName="activity"
                id="activity"
                class="bg-white w-full mt-1 px-3 py-2 rounded-lg shadow-sm border-gray-300 focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
              >
                <option
                  *ngFor="let activity of activities"
                  [value]="activity?.id"
                >
                  <strong> {{ activity?.nomActivity | titlecase }}</strong>
                </option>
              </select>

              <!-- Chargement de fichier -->
              <div
                class="form-fields-ctnr pr-db col-span-2 wysiwyg-ctnr self-stretch justify-start items-start gap-6 py-2"
              >
                <div
                  class="field-ctnr pt-6 gap-5 text-center px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center"
                >
                  <!-- Debut -->
                  <label
                    for="ledocument"
                    class="mt-3 flex flex-col items-center justify-center border-4 border-gray-300 border-dashed rounded h-36 px-6 text-lg text-gray-600 focus:outline-none focus:ring focus:border-blue-300 cursor-pointer"
                    autocomplete="off"
                  >
                    <svg
                      class="w-8 h-8 text-gray-600"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                      />
                    </svg>
                    <span
                      class="mt-2 text-base leading-normal text-blue-500 font-bold"
                      >Selectionner un fichier (excel)</span
                    >
                    <ng-container *ngIf="fileIsValid == true">
                      <span
                        *ngIf="fileSize && fileSize < maxFileSize"
                        class="mt-2 text-base leading-normal text-green-500 font-bold"
                      >
                        {{ fileName }}
                      </span>
                    </ng-container>
                    <span
                      *ngIf="!fileIsValid"
                      class="mt-2 text-base leading-normal text-red-500 font-bold"
                    >
                      Fichier invalide
                    </span>
                    <span
                      *ngIf="fileSize && fileSize >= maxFileSize"
                      class="mt-2 text-base leading-normal text-red-500 font-bold"
                    >
                      Merci de choisir un autre fichier, taille de fichier trop
                      grande : {{ fileSize }} KB
                    </span>
                    <input
                      id="ledocument"
                      type="file"
                      formControlName="file"
                      accept=".xlsx,.xls"
                      class="hidden"
                      (change)="onChangeBis($event)"
                    />
                  </label>
                </div>
              </div>
              <div class="flex justify-between items-center mt-2 p-5">
                <p>
                  Merci de
                  <a
                    href="{{ url }}/opencontroller/content/{{ id_Document }}"
                    class="text-blue-500"
                  >
                    télécharger le modele de fichier
                  </a>
                  joint puis le compléter. Une fois complété avec la liste des
                  invités vous pourrez revenir ici pour l'envoyer.
                </p>
              </div>
            </div>

            <div class="flex justify-end">
              <button
                type="button"
                class="mr-4 inline-flex items-center transition px-4 py-2 bg-red bg-redDark border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest transition"
                (click)="onCancel()"
              >
                Annuler
              </button>
              <button
                type="submit"
                [disabled]="sendMessageForm.invalid || isSubmitting"
                class="inline-flex items-center transition px-4 py-2 bg-green-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-green-700 active:bg-green-700 focus:outline-none focus:border-green-700 focus:ring ring-green-300 disabled:opacity-25 transition ease-in-out duration-150"
                (click)="onSubmitForm()"
              >
                Envoyer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
